<template>
    <div class="update-class-container">
        <el-dialog
                title="更新班级"
                :visible.sync="$store.state.updateClassDialog"
                width="30%"
                :before-close="handleClose"
                :close-on-click-modal="clickModalClose"
                @open="openDialog"
                >
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="班级名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="开课日期" prop="date">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.date" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="上课时间" prop="time">
                    <el-time-picker
                            is-range
                            v-model="form.time"
                            style="width: 100%"
                            format="HH:mm"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="课程周期" prop="cycle">
                    <el-checkbox-group v-model="form.cycle">
                        <el-checkbox-button label="0" name="cycle" value="0" style="width: 14%">周日</el-checkbox-button>
                        <el-checkbox-button label="1" name="cycle" value="1" style="width: 14%">周一</el-checkbox-button>
                        <el-checkbox-button label="2" name="cycle" value="2" style="width: 14%">周二</el-checkbox-button>
                        <el-checkbox-button label="3" name="cycle" value="3" style="width: 14%">周三</el-checkbox-button>
                        <el-checkbox-button label="4" name="cycle" value="4" style="width: 14%">周四</el-checkbox-button>
                        <el-checkbox-button label="5" name="cycle" value="5" style="width: 14%">周五</el-checkbox-button>
                        <el-checkbox-button label="6" name="cycle" value="6" style="width: 14%">周六</el-checkbox-button>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="课程次数" prop="count">
                    <el-input v-model="form.count"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="updateClass">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {saveLocal, loadLocal} from 'common/js/store.js';

    export default {
        name: "updateClass",
        data () {
            const userInfo = loadLocal('userinfo');
            return {
                clickModalClose: false,
                id: userInfo.id,
                rid: userInfo.bindrid,
                lessonId: '',
                classId: '',
                form: {
                    name: '',
                    date: '',
                    time: '',
                    cycle: [],
                    count: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入班级名称', trigger: 'change' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change' }
                    ],
                    date: [
                        { required: true, message: '请选择开课日期', trigger: 'change' },
                    ],
                    time: [
                        { required: true, message: '请选择开课时间', trigger: 'change' },
                    ],
                    cycle: [
                        { required: true, message: '请选择开课周期', trigger: 'change' },
                    ],
                    count: [
                        { required: true, message: '请输入课程次数', trigger: 'change' },
                        { pattern: /^[1-9]$|^\d{2,3}$/, message: '课程次数为不能超过999的数字', trigger: 'change'}
                    ],
                }
            }
        },
        props: ['dialogVisible'],
        methods: {
            // 打开弹窗
            openDialog () {
                const classInfo = loadLocal('classinfo');
                this.lessonId = classInfo.lessonid;
                this.classId = classInfo.id;
                this.form = {
                    name: decodeURIComponent(classInfo.classname),
                    date: new Date(classInfo.startdate),
                    time: [new Date(classInfo.startdate + ' ' + classInfo.starttime), new Date(classInfo.startdate + ' ' + classInfo.endtime)],
                    cycle: classInfo.classcycle.split(','),
                    count: classInfo.totalnumber
                }
            },

            updateClass () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.editClass();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },

            handleClose () {
                this.$store.commit('setUpdateClassDialog', false)
            },

            // 编辑班级
            editClass () {
                Date.prototype.format = function(fmt) {
                    var o = {
                        "M+" : this.getMonth()+1,                 //月份
                        "d+" : this.getDate(),                    //日
                        "h+" : this.getHours(),                   //小时
                        "m+" : this.getMinutes(),                 //分
                        "s+" : this.getSeconds(),                 //秒
                        "q+" : Math.floor((this.getMonth()+3)/3), //季度
                        "S"  : this.getMilliseconds()             //毫秒
                    };
                    if(/(y+)/.test(fmt)) {
                        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
                    }
                    for(var k in o) {
                        if(new RegExp("("+ k +")").test(fmt)){
                            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                        }
                    }
                    return fmt;
                };

                const params = {
                    id: this.id,
                    rid: this.rid,
                    lessonid: this.lessonId,
                    classid: this.classId,
                    classname: encodeURIComponent(this.form.name),
                    classcycle: this.form.cycle.sort((a, b) => a - b).toString(),
                    startdate: this.form.date.format('yyyy-MM-dd'),
                    starttime: this.form.time[0].format('hh:mm:ss'),
                    endtime: this.form.time[1].format('hh:mm:ss'),
                    totalnumber: this.form.count,
                };

                this.$http({
                    url: '/indexapp.php?c=Lesson&a=updateClass',
                    method: 'GET',
                    params
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.$message({
                            message: '更新班级成功',
                            type: 'success'
                        });
                        const classInfo = loadLocal('classinfo');
                        classInfo.classname = params.classname;
                        classInfo.classcycle = params.classcycle;
                        classInfo.startdate = params.startdate;
                        classInfo.starttime = params.starttime;
                        classInfo.endtime = params.endtime;
                        classInfo.totalnumber = params.totalnumber;
                        saveLocal('classinfo', classInfo);
                    }
                    this.$store.commit('setUpdateClassDialog', false);
                }).catch((err) => {
                    console.log(err);
                })
            },
        }
    }
</script>

<style lang="scss">
.update-class-container {
    .el-checkbox-button {
        &.is-focus {
           span {
               border-color: #dcdfe6;
           }
        }
        &.is-checked {
            span {
                border-color: #409EFF;
            }
        }
        span {
            display: inline-block;
            width: 100%;
            text-align: center;
            padding: 12px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/updateClass/UpdateClass.vue